import { api } from './client';
import type { AuthSession, AccountView, IdentityProfileView } from '../types/api';

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresAt?: string;
  expiresIn?: number;
  account: AccountView;
  activeIdentity?: IdentityProfileView | null;
}

interface MeResponse {
  account: AccountView;
  identities: IdentityProfileView[];
}

export const authApi = {
  /** Login with email and password.
   *  Note: Backend currently only supports wechat-login (T1-1).
   *  This endpoint will require T1-1 extension for email+password login. */
  async login(email: string, password: string): Promise<AuthSession> {
    const result = await api.post<LoginResponse>('/auth/login', {
      email,
      password,
    } satisfies LoginRequest);
    return {
      accessToken: result.accessToken,
      refreshToken: result.refreshToken,
      expiresAt: result.expiresAt ?? expiresAtFromSeconds(result.expiresIn),
      account: result.account,
    };
  },

  /** Get current account info. */
  async getMe(): Promise<AccountView> {
    const result = await api.get<MeResponse>('/me');
    return {
      ...result.account,
      identities: result.identities,
    };
  },

  /** Logout and revoke tokens. */
  async logout(): Promise<void> {
    await api.post<void>('/auth/logout');
  },
};

function expiresAtFromSeconds(expiresIn?: number): string {
  return new Date(Date.now() + (expiresIn ?? 900) * 1000).toISOString();
}
